module.exports = __webpack_public_path__ + "static/saral-f4998dce3d26ccbddac9c84fb74685e9.jpg";